/* eslint-env browser */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Parser } from 'html-to-react';
import draftToHtml from 'draftjs-to-html';
import { imageUrlUtil } from '../../Utils/otherUtils';
import { setContactNotification } from '../../Actions/ToggleActions';

class TabContactComponent extends Component {
  constructor() {
    super();

    this.htmlToReactParser = new Parser();
  }

  componentDidMount() {
    const {
      dispatch,
    } = this.props;

    dispatch(setContactNotification(false));
  }

  render() {
    const {
      MunicipalityReducer: { contact },
      Language: { language, text: { tabContact } },
    } = this.props;

    return (
      <div className="tab-contact-inner">
        <h2 className="m0">{tabContact.contact}</h2>
        <div style={{ backgroundImage: `url(${imageUrlUtil(contact.portrait).thumb})` }} className="portrait" alt="portrait" />
        {this.htmlToReactParser.parse(draftToHtml(contact.body[language].content))}
        <input
          type="button"
          value={contact.emailBtn[language]}
          className="btn theme w100 mt10"
          onClick={() => {
            window.location.href = `mailto:${contact.email}?subject=Välkommen hit kontaktformulär`;
           }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ToggleReducer: state.ToggleReducer,
  MunicipalityReducer: state.MunicipalityReducer,
  Language: state.Language,
});

export default connect(mapStateToProps)(TabContactComponent);



// WEBPACK FOOTER //
// ./src/Components/Tabs/TabContactComponent.js